import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSimulationStore, useIsSimulating } from '@/stores/simulationStore';
import { LAGEN } from '@xxtract/ui';
import { cn } from '@/lib/utils';

export function SimulationBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSimulating = useIsSimulating();
  const { simulatedCompanyName, stopSimulation } = useSimulationStore();

  if (!isSimulating) return null;

  const handleStop = () => {
    stopSimulation();
    navigate('/clients');
  };

  return (
    <div
      data-testid="simulation-banner"
      role="status"
      aria-live="polite"
      className={cn('sticky top-14 flex h-9 items-center justify-center gap-2 px-4 text-sm font-medium', LAGEN.nabootsingsbalk)}
      style={{
        backgroundColor: 'var(--warning)',
        color: '#fff',
      }}
    >
      <span
        className="material-symbols-outlined"
        style={{ fontSize: '16px' }}
        aria-hidden="true"
      >
        visibility
      </span>
      <span>
        {t('simulation.viewingAs', { company: simulatedCompanyName })}
      </span>
      <button
        data-testid="simulation-stop"
        onClick={handleStop}
        className="ml-4 rounded px-2 py-0.5 text-xs font-semibold transition-colors hover:bg-white/20"
        style={{ border: '1px solid rgba(255,255,255,0.4)' }}
      >
        {t('simulation.stop')}
      </button>
    </div>
  );
}
